import { cn } from "@/design-system/lib/utils";

/**
 * "LIVE — real funds" indicator shown wherever staff see an escrow transaction
 * when the server resolves to the LIVE Escrow.com API (not the sandbox).
 * Deliberately loud — red + a pulsing dot — so no one mistakes a live
 * transaction for a sandbox one. Renders nothing unless `isLive` is true, so it
 * is safe to drop in unconditionally.
 */
export function EscrowLiveBadge({
  isLive,
  className,
}: {
  isLive?: boolean;
  className?: string;
}) {
  if (!isLive) return null;
  return (
    <span
      role="status"
      title="Connected to the LIVE Escrow.com API — actions here move real funds."
      className={cn(
        "inline-flex items-center gap-space-1 px-space-2 py-[4px] rounded-sm",
        "font-display text-[10px] font-bold uppercase tracking-[0.16em]",
        "bg-status-error text-white-pure",
        className,
      )}
    >
      <span aria-hidden className="inline-block h-1.5 w-1.5 rounded-full bg-white-pure animate-pulse" />
      LIVE — real funds
    </span>
  );
}
